import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ChecklistSquareIcon = React.forwardRef(function ChecklistSquareIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 2C3.80228 2 2 3.80228 2 6V18C2 20.1977 3.80228 22 6 22H18C20.1977 22 22 20.1977 22 18V6C22 3.80228 20.1977 2 18 2H6ZM0 6C0 2.69772 2.69772 0 6 0H18C21.3023 0 24 2.69772 24 6V18C24 21.3023 21.3023 24 18 24H6C2.69772 24 0 21.3023 0 18V6Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 8C14 7.44772 14.4477 7 15 7H19C19.5523 7 20 7.44772 20 8 20 8.55228 19.5523 9 19 9H15C14.4477 9 14 8.55228 14 8ZM11.7071 13.2929C12.0976 13.6834 12.0976 14.3166 11.7071 14.7071L7 19.4142 4.29289 16.7071C3.90237 16.3166 3.90237 15.6834 4.29289 15.2929 4.68342 14.9024 5.31658 14.9024 5.70711 15.2929L7 16.5858 10.2929 13.2929C10.6834 12.9024 11.3166 12.9024 11.7071 13.2929ZM14 17C14 16.4477 14.4477 16 15 16H19C19.5523 16 20 16.4477 20 17 20 17.5523 19.5523 18 19 18H15C14.4477 18 14 17.5523 14 17ZM11.7071 5.29289C12.0976 5.68342 12.0976 6.31658 11.7071 6.70711L7 11.4142 4.29289 8.70711C3.90237 8.31658 3.90237 7.68342 4.29289 7.29289 4.68342 6.90237 5.31658 6.90237 5.70711 7.29289L7 8.58579 10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

ChecklistSquareIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ChecklistSquareIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ChecklistSquareIcon
